import { SceneWrapper } from '~/components';
import { styled } from '~/modules';

export const Wrapper = styled(SceneWrapper)`
  justify-content: center;
  flex: 1;
`;
